module.exports = "/legacy/80fcc6ff96473a176503598c993e40a6.png";